import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { LoginGuard } from './pages/auth/check-login.guard';

const routes: Routes = [
  {
    path: '',
    loadChildren: () =>
      import('./pages/tabs/tabs.module').then((m) => m.TabsPageModule),
    // canActivate: [LoginGuard],
  },
  {
    path: 'sign-in/:params',
    loadChildren: () =>
      import('./pages/sign-in/sign-in.module').then((m) => m.SignInPageModule),
    // canActivate: [LoginGuard],
  },
  {
    path: 'booking-home',
    loadChildren: () =>
      import('./pages/booking/booking-home/booking-home.module').then(
        (m) => m.BookingHomePageModule
      ),
    // canActivate: [LoginGuard],
  },
  {
    path: 'notifications',
    loadChildren: () =>
      import('./pages/notifications/notifications.module').then(
        (m) => m.NotificationsPageModule
      ),
    canActivate: [LoginGuard],
  },
  {
    path: 'faq',
    loadChildren: () =>
      import('./pages/faq/faq.module').then((m) => m.FaqPageModule),
  },
  {
    path: 'booking-details',
    loadChildren: () =>
      import('./pages/booking/booking-details/booking-details.module').then(
        (m) => m.BookingDetailsPageModule
      ),
  },
  {
    path: 'profile',
    loadChildren: () =>
      import('./pages/profile/profile.module').then((m) => m.ProfilePageModule),
    // canActivate: [LoginGuard],
  },
  {
    path: 'sign-in',
    loadChildren: () =>
      import('./pages/sign-in/sign-in.module').then((m) => m.SignInPageModule),
  },
  {
    path: 'competition-filter',
    loadChildren: () =>
      import(
        './pages/competition/competition-filter/competition-filter.module'
      ).then((m) => m.CompetitionFilterPageModule),
  },
  {
    path: 'competition-scoring',
    loadChildren: () =>
      import(
        './pages/competition/competition-scoring/competition-scoring.module'
      ).then((m) => m.CompetitionScoringPageModule),
    // canActivate: [LoginGuard],
  },

  // {
  //   path: 'competition-teams',
  //   loadChildren: () =>
  //     import(
  //       './pages/competition/competition-teams/competition-teams.module'
  //     ).then((m) => m.CompetitionTeamsPageModule),
  //   canActivate: [LoginGuard],
  // },
  {
    path: 'sign-up',
    loadChildren: () =>
      import('./pages/sign-up/sign-up.module').then((m) => m.SignUpPageModule),
  },
  {
    path: 'settings',
    loadChildren: () =>
      import('./pages/settings/settings.module').then(
        (m) => m.SettingsPageModule
      ),
    // canActivate: [LoginGuard],
  },
  {
    path: 'forgot-password',
    loadChildren: () =>
      import('./pages/forgot-password/forgot-password.module').then(
        (m) => m.ForgotPasswordPageModule
      ),
  },
  {
    path: 'handicap-history',
    loadChildren: () =>
      import('./pages/handicap-history/handicap-history.module').then(
        (m) => m.HandicapHistoryPageModule
      ),
    // canActivate: [LoginGuard],
  },
  {
    path: 'help-content',
    loadChildren: () =>
      import('./pages/help-content/help-content.module').then(
        (m) => m.HelpContentPageModule
      ),
  },
  {
    path: 'player-list',
    loadChildren: () =>
      import('./pages/modal-screens/player-list/player-list.module').then(
        (m) => m.PlayerListPageModule
      ),
    canActivate: [LoginGuard],
  },
  {
    path: 'country-list',
    loadChildren: () =>
      import('./pages/modal-screens/country-list/country-list.module').then(
        (m) => m.CountryListPageModule
      ),
    canActivate: [LoginGuard],
  },
  {
    path: 'change-password',
    loadChildren: () =>
      import('./pages/change-password/change-password.module').then(
        (m) => m.ChangePasswordPageModule
      ),
  },
  {
    path: 'about',
    loadChildren: () =>
      import('./pages/about/about.module').then((m) => m.AboutPageModule),
  },
  {
    path: 'feedback',
    loadChildren: () =>
      import('./pages/feedback/feedback.module').then(
        (m) => m.FeedbackPageModule
      ),
  },
  {
    path: 'contact-us',
    loadChildren: () =>
      import('./pages/contact-us/contact-us.module').then(
        (m) => m.ContactUsPageModule
      ),
  },
  {
    path: 'help-content',
    loadChildren: () =>
      import('./pages/help-content/help-content.module').then(
        (m) => m.HelpContentPageModule
      ),
  },
  {
    path: 'change-password',
    loadChildren: () =>
      import('./pages/change-password/change-password.module').then(
        (m) => m.ChangePasswordPageModule
      ),
    canActivate: [LoginGuard],
  },
  {
    path: 'description-modal',
    loadChildren: () =>
      import(
        './pages/competition/competitions-modal/description-modal/description-modal.module'
      ).then((m) => m.DescriptionModalPageModule),
    canActivate: [LoginGuard],
  },
  {
    path: 'rules-modal',
    loadChildren: () =>
      import(
        './pages/competition/competitions-modal/rules-modal/rules-modal.module'
      ).then((m) => m.RulesModalPageModule),
    canActivate: [LoginGuard],
  },
  {
    path: 'courses-modal',
    loadChildren: () =>
      import(
        './pages/competition/competitions-modal/courses-modal/courses-modal.module'
      ).then((m) => m.CoursesModalPageModule),
    canActivate: [LoginGuard],
  },
  {
    path: 'full-info-modal',
    loadChildren: () =>
      import(
        './pages/competition/competitions-modal/full-info-modal/full-info-modal.module'
      ).then((m) => m.FullInfoModalPageModule),
    canActivate: [LoginGuard],
  },
  // {
  //   path: 'booking-calendar',
  //   loadChildren: () =>
  //     import('./pages/booking/booking-calendar/booking-calendar.module').then(
  //       (m) => m.BookingCalendarPageModule
  //     ),
  // },
  {
    path: 'booking-charts',
    loadChildren: () =>
      import('./pages/booking/booking-charts/booking-charts.module').then(
        (m) => m.BookingChartsPageModule
      ),
  },
  {
    path: 'booking-club-list',
    loadChildren: () =>
      import('./pages/booking/booking-club-list/booking-club-list.module').then(
        (m) => m.BookingClubListPageModule
      ),
  },
  {
    path: 'booking-detail-modal',
    loadChildren: () =>
      import(
        './pages/booking/booking-detail-modal/booking-detail-modal.module'
      ).then((m) => m.BookingDetailModalPageModule),
  },
  {
    path: 'booking-list',
    loadChildren: () =>
      import('./pages/booking/booking-list/booking-list.module').then(
        (m) => m.BookingListPageModule
      ),
  },
  {
    path: 'booking-search',
    loadChildren: () =>
      import('./pages/booking/booking-search/booking-search.module').then(
        (m) => m.BookingSearchPageModule
      ),
  },
  {
    path: 'by-club',
    loadChildren: () =>
      import('./pages/booking/by-club/by-club.module').then(
        (m) => m.ByClubPageModule
      ),
  },
  {
    path: 'caddy-flight-details',
    loadChildren: () =>
      import(
        './pages/booking/caddy-flight-details/caddy-flight-details.module'
      ).then((m) => m.CaddyFlightDetailsPageModule),
  },
  {
    path: 'caddy-flight-lists',
    loadChildren: () =>
      import(
        './pages/booking/caddy-flight-lists/caddy-flight-lists.module'
      ).then((m) => m.CaddyFlightListsPageModule),
  },
  {
    path: 'chart',
    loadChildren: () =>
      import('./pages/booking/chart/chart.module').then(
        (m) => m.ChartPageModule
      ),
  },
  {
    path: 'club-booking-list',
    loadChildren: () =>
      import('./pages/booking/club-booking-list/club-booking-list.module').then(
        (m) => m.ClubBookingListPageModule
      ),
  },
  {
    path: 'club-calendar',
    loadChildren: () =>
      import('./pages/booking/club-calendar/club-calendar.module').then(
        (m) => m.ClubCalendarPageModule
      ),
  },
  {
    path: 'club-refund-redeem-history',
    loadChildren: () =>
      import(
        './pages/booking/club-refund-redeem-history/club-refund-redeem-history.module'
      ).then((m) => m.ClubRefundRedeemHistoryPageModule),
  },
  {
    path: 'flight-buggy-lists',
    loadChildren: () =>
      import(
        './pages/booking/flight-buggy-lists/flight-buggy-lists.module'
      ).then((m) => m.FlightBuggyListsPageModule),
  },
  {
    path: 'player-facility-home',
    loadChildren: () =>
      import(
        './pages/booking/player-facility-home/player-facility-home.module'
      ).then((m) => m.PlayerFacilityHomePageModule),
  },
  {
    path: 'player-option-modal',
    loadChildren: () =>
      import(
        './pages/booking/player-option-modal/player-option-modal.module'
      ).then((m) => m.PlayerOptionModalPageModule),
  },
  // {
  //   path: 'slots-detail',
  //   loadChildren: () =>
  //     import('./pages/booking/slots-detail/slots-detail.module').then(
  //       (m) => m.SlotsDetailPageModule
  //     ),
  // },
  // {
  //   path: 'starter-flight-lists',
  //   loadChildren: () =>
  //     import(
  //       './pages/booking/starter-flight-lists/starter-flight-lists.module'
  //     ).then((m) => m.StarterFlightListsPageModule),
  // },
  {
    path: 'tee-buggy-list',
    loadChildren: () =>
      import('./pages/booking/tee-buggy-list/tee-buggy-list.module').then(
        (m) => m.TeeBuggyListPageModule
      ),
  },
  // {
  //   path: 'tee-flight-lists',
  //   loadChildren: () =>
  //     import('./pages/booking/tee-flight-lists/tee-flight-lists.module').then(
  //       (m) => m.TeeFlightListsPageModule
  //     ),
  // },
  {
    path: 'date-and-time',
    loadChildren: () =>
      import('./pages/modal-screens/date-and-time/date-and-time.module').then(
        (m) => m.DateAndTimePageModule
      ),
  },
  {
    path: 'scorecard-display',
    loadChildren: () =>
      import('./pages/scorecard-display/scorecard-display.module').then(
        (m) => m.ScorecardDisplayPageModule
      ),
  },
  {
    path: 'recent-club',
    loadChildren: () =>
      import('./pages/performance/recent-club/recent-club.module').then(
        (m) => m.RecentClubPageModule
      ),
  },
  {
    path: 'manage-voucher',
    loadChildren: () =>
      import('./pages/modal-screens/manage-voucher/manage-voucher.module').then(
        (m) => m.ManageVoucherPageModule
      ),
  },
  {
    path: 'handicap-history-details',
    loadChildren: () =>
      import(
        './pages/handicap-history-details/handicap-history-details.module'
      ).then((m) => m.HandicapHistoryDetailsPageModule),
  },
  {
    path: 'scorecard-list',
    loadChildren: () =>
      import('./pages/scorecard-list/scorecard-list.module').then(
        (m) => m.ScorecardListPageModule
      ),
  },
  {
    path: 'select-courses',
    loadChildren: () =>
      import('./pages/normalgame/select-courses/select-courses.module').then(
        (m) => m.SelectCoursesPageModule
      ),
  },
  {
    path: 'flight-setup',
    loadChildren: () =>
      import('./pages/normalgame/flight-setup/flight-setup.module').then(
        (m) => m.FlightSetupPageModule
      ),
  },
  {
    path: 'course-box',
    loadChildren: () =>
      import('./pages/modal-screens/course-box/course-box.module').then(
        (m) => m.CourseBoxPageModule
      ),
  },
  {
    path: 'course-lists',
    loadChildren: () =>
      import('./pages/normalgame/course-list/course-list.module').then(
        (m) => m.CourseListPageModule
      ),
  },
  {
    path: 'search-player-list',
    loadChildren: () =>
      import('./pages/search-player-list/search-player-list.module').then(
        (m) => m.SearchPlayerListPageModule
      ),
  },
  {
    path: 'hole-analysis',
    loadChildren: () =>
      import('./pages/hole-analysis/hole-analysis.module').then(
        (m) => m.HoleAnalysisPageModule
      ),
  },
  {
    path: 'club-list1',
    loadChildren: () =>
      import('./pages/performance/club-list1/club-list1.module').then(
        (m) => m.ClubList1PageModule
      ),
  },
  {
    path: 'course-list',
    loadChildren: () =>
      import('./pages/performance/course-list/course-list.module').then(
        (m) => m.CourseListPageModule
      ),
  },
  {
    path: 'event-log',
    loadChildren: () =>
      import('./pages/event-log/event-log.module').then(
        (m) => m.EventLogPageModule
      ),
  },
  {
    path: 'new-contact',
    loadChildren: () =>
      import('./pages/new-contact/new-contact.module').then(
        (m) => m.NewContactPageModule
      ),
  },
  {
    path: 'setup-player-courses',
    loadChildren: () =>
      import(
        './pages/normalgame/select-courses/setup-player-courses/setup-player-courses.module'
      ).then((m) => m.SetupPlayerCoursesPageModule),
  },
  {
    path: 'add-player-list',
    loadChildren: () =>
      import(
        './pages/modal-screens/add-player-list/add-player-list.module'
      ).then((m) => m.AddPlayerListPageModule),
  },
  {
    path: 'club-membership-list-old',
    loadChildren: () =>
      import(
        './pages/modal-screens/club-membership-list/club-membership-list.module'
      ).then((m) => m.ClubMembershipListPageModule),
  },
  {
    path: 'additional;-items-list',
    loadChildren: () =>
      import(
        './pages/modal-screens/additional-items-list/additional-items-list.module'
      ).then((m) => m.AdditionalItemsListModalModule),
  },
  {
    path: 'player-groups',
    loadChildren: () =>
      import('./pages/player-groups/player-groups.module').then(
        (m) => m.PlayerGroupsPageModule
      ),
  },
  {
    path: 'caddy-list',
    loadChildren: () =>
      import('./pages/modal-screens/caddy-list/caddy-list.module').then(
        (m) => m.CaddyListPageModule
      ),
  },
  {
    path: 'player-address',
    loadChildren: () =>
      import('./pages/modal-screens/player-address/player-address.module').then(
        (m) => m.PlayerAddressPageModule
      ),
  },
  {
    path: 'prices-display',
    loadChildren: () =>
      import('./pages/modal-screens/prices-display/prices-display.module').then(
        (m) => m.PricesDisplayPageModule
      ),
  },
  {
    path: 'edit-profile',
    loadChildren: () =>
      import('./pages/edit-profile/edit-profile.module').then(
        (m) => m.EditProfilePageModule
      ),
  },
  {
    path: 'image-zoom',
    loadChildren: () =>
      import('./pages/modal-screens/image-zoom/image-zoom.module').then(
        (m) => m.ImageZoomPageModule
      ),
  },
  {
    path: 'tee-slot-list',
    loadChildren: () =>
      import('./pages/modal-screens/tee-slot-list/tee-slot-list.module').then(
        (m) => m.TeeSlotListPageModule
      ),
  },
  {
    path: 'player-voucher',
    loadChildren: () =>
      import('./pages/modal-screens/player-voucher/player-voucher.module').then(
        (m) => m.PlayerVoucherPageModule
      ),
  },
  {
    path: 'voucher-list',
    loadChildren: () =>
      import('./pages/modal-screens/voucher-list/voucher-list.module').then(
        (m) => m.VoucherListPageModule
      ),
  },
  {
    path: 'redeem-player-club-credits',
    loadChildren: () =>
      import(
        './pages/modal-screens/redeem-player-club-credits/redeem-player-club-credits.module'
      ).then((m) => m.RedeemPlayerClubCreditsPageModule),
  },
  {
    path: 'buggy-seating',
    loadChildren: () =>
      import('./pages/modal-screens/buggy-seating/buggy-seating.module').then(
        (m) => m.BuggySeatingPageModule
      ),
  },
  {
    path: 'gameround-scoring',
    loadChildren: () =>
      import('./pages/gameround-scoring/gameround-scoring.module').then(
        (m) => m.GameroundScoringPageModule
      ),
  },
  {
    path: 'matchplay-scoring',
    loadChildren: () =>
      import('./pages/matchplay-scoring/matchplay-scoring.module').then(
        (m) => m.MatchplayScoringPageModule
      ),
  },
  {
    path: 'friend-list',
    loadChildren: () =>
      import('./pages/normalgame/friend-list/friend-list.module').then(
        (m) => m.FriendListPageModule
      ),
  },
  {
    path: 'tee-box',
    loadChildren: () =>
      import('./pages/modal-screens/tee-box/tee-box.module').then(
        (m) => m.TeeBoxPageModule
      ),
  },
  {
    path: 'club-list',
    loadChildren: () =>
      import('./pages/normalgame/club-list/club-list.module').then(
        (m) => m.ClubListPageModule
      ),
  },
  {
    path: 'change-course',
    loadChildren: () =>
      import('./pages/normalgame/change-course/change-course.module').then(
        (m) => m.ChangeCoursePageModule
      ),
  },
  {
    path: 'scorecard-filter',
    loadChildren: () =>
      import('./pages/scorecard-filter/scorecard-filter.module').then(
        (m) => m.ScoreboardFilterPageModule
      ),
  },
  {
    path: 'edit-teeoff',
    loadChildren: () =>
      import('./pages/modal-screens/edit-teeoff/edit-teeoff.module').then(
        (m) => m.EditTeeoffPageModule
      ),
  },
  {
    path: 'scorecard-local-list',
    loadChildren: () =>
      import('./pages/scorecard-local-list/scorecard-local-list.module').then(
        (m) => m.ScorecardLocalListPageModule
      ),
  },
  {
    path: 'scoring-test',
    loadChildren: () =>
      import('./pages/scoring-test/scoring-test.module').then(
        (m) => m.ScoringTestPageModule
      ),
  },
  {
    path: 'modal-competition',
    loadChildren: () =>
      import('./pages/modal-competition/modal-competition.module').then(
        (m) => m.ModalCompetitionPageModule
      ),
  },
  // {
  //   path: 'group-booking-option',
  //   loadChildren: () => import('./pages/modal-screens/group-booking-option/group-booking-option.module').then(m => m.GroupBookingOptionPageModule)
  // },
  {
    path: 'refund-booking-players',
    loadChildren: () =>
      import(
        './pages/modal-screens/refund-booking-players/refund-booking-players.module'
      ).then((m) => m.RefundBookingPlayersPageModule),
  },
  {
    path: 'buggy-list',
    loadChildren: () =>
      import('./pages/modal-screens/buggy-list/buggy-list.module').then(
        (m) => m.BuggyListPageModule
      ),
  },
  // {
  //   path: 'caddy-schedule-display',
  //   loadChildren: () => import('./pages/modal-screens/caddy-schedule-display/caddy-schedule-display.module').then(m => m.CaddyScheduleDisplayPageModule)
  // },
  {
    path: 'courses-display',
    loadChildren: () =>
      import(
        './pages/modal-screens/courses-display/courses-display.module'
      ).then((m) => m.CoursesDisplayPageModule),
  },
  {
    path: 'description-box',
    loadChildren: () =>
      import(
        './pages/modal-screens/description-box/description-box.module'
      ).then((m) => m.DescriptionBoxPageModule),
  },

  {
    path: 'select-dates',
    loadChildren: () =>
      import('./pages/modal-screens/select-dates/select-dates.module').then(
        (m) => m.SelectDatesPageModule
      ),
  },
  {
    path: 'external-payment',
    loadChildren: () =>
      import(
        './pages/modal-screens/external-payment/external-payment.module'
      ).then((m) => m.ExternalPaymentPageModule),
  },
  {
    path: 'test-payment',
    loadChildren: () =>
      import('./pages/modal-screens/test-payment/test-payment.module').then(
        (m) => m.TestPaymentPageModule
      ),
  },
  {
    path: 'player-club-handicap',
    loadChildren: () =>
      import(
        './pages/modal-screens/player-club-handicap/player-club-handicap.module'
      ).then((m) => m.PlayerClubHandicapPageModule),
  },
  {
    path: 'player-refund-redeem-history',
    loadChildren: () =>
      import(
        './pages/modal-screens/player-refund-redeem-history/player-refund-redeem-history.module'
      ).then((m) => m.PlayerRefundRedeemHistoryPageModule),
  },
  {
    path: 'player-subscription',
    loadChildren: () =>
      import(
        './pages/modal-screens/player-subscription/player-subscription.module'
      ).then((m) => m.PlayerSubscriptionPageModule),
  },

  {
    path: 'ratings-list',
    loadChildren: () =>
      import('./pages/modal-screens/ratings-list/ratings-list.module').then(
        (m) => m.RatingsListPageModule
      ),
  },
  {
    path: 'member-menu',
    loadChildren: () =>
      import('./pages/modal-screens/member-menu/member-menu.module').then(
        (m) => m.MemberMenuPageModule
      ),
  },
  {
    path: 'club-home',
    loadChildren: () =>
      import('./pages/club/club-home/club-home.module').then(
        (m) => m.ClubHomePageModule
      ),
  },
  {
    path: 'hole-googlemap',
    // component: HoleGoogleMapPage
    loadChildren: () =>
      import(
        './pages/gameround-scoring/hole-googlemap/hole-googlemap.module'
      ).then((m) => m.HoleGooglemapPageModule),
  },
  {
    path: 'player-favourite-list',
    loadChildren: () =>
      import('./pages/player-favourite-list/player-favourite-list.module').then(
        (m) => m.PlayerFavouriteListPageModule
      ),
  },
  {
    path: 'add-location',
    loadChildren: () =>
      import('./pages/add-location/add-location.module').then(
        (m) => m.AddLocationPageModule
      ),
  },
  {
    path: 'add-state-list',
    loadChildren: () =>
      import('./pages/add-state-list/add-state-list.module').then(
        (m) => m.AddStateListPageModule
      ),
  },
  {
    path: 'add-club-list',
    loadChildren: () =>
      import('./add-club-list/add-club-list.module').then(
        (m) => m.AddClubListPageModule
      ),
  },

  {
    path: 'player-mg2u-credits',
    loadChildren: () =>
      import(
        './pages/modal-screens/player-mg2u-credits/player-mg2u-credits.module'
      ).then((m) => m.PlayerMg2uCreditsPageModule),
  },
  {
    path: 'outlet-list',
    loadChildren: () =>
      import('./pages/modal-screens/outlet-list/outlet-list.module').then(
        (m) => m.OutletListPageModule
      ),
  },
  {
    path: 'packages',
    loadChildren: () =>
      import('./pages/packages/packages.module').then(
        (m) => m.PackagesPageModule
      ),
  },
  {
    path: 'package-details',
    loadChildren: () =>
      import('./pages/package-details/package-details.module').then(
        (m) => m.PackageDetailsPageModule
      ),
  },
  {
    path: 'package-booking',
    loadChildren: () =>
      import('./pages/package-booking/package-booking.module').then(
        (m) => m.PackageBookingPageModule
      ),
  },
  {
    path: 'handicap-membership-add',
    loadChildren: () =>
      import(
        './pages/modal-screens/handicap-membership/handicap-membership-add/handicap-membership-add.module'
      ).then((m) => m.HandicapMembershipAddPageModule),
  },
  {
    path: 'user-list-address',
    loadChildren: () =>
      import(
        './pages/user-profile/user-list-address/user-list-address.module'
      ).then((m) => m.UserListAddressPageModule),
  },
  {
    path: 'user-manage-address',
    loadChildren: () =>
      import(
        './pages/user-profile/user-manage-address/user-manage-address.module'
      ).then((m) => m.UserManageAddressPageModule),
  },
  {
    path: 'account-option',
    loadChildren: () =>
      import('./pages/modal-screens/account-option/account-option.module').then(
        (m) => m.AccountOptionPageModule
      ),
  },
  {
    path: 'player-add-club-membership',
    loadChildren: () =>
      import(
        './pages/player-club-membership/player-add-club-membership/player-add-club-membership.module'
      ).then((m) => m.PlayerAddClubMembershipPageModule),
  },
  {
    path: 'player-details-club-membership',
    loadChildren: () =>
      import(
        './pages/player-club-membership/player-details-club-membership/player-details-club-membership.module'
      ).then((m) => m.PlayerDetailsClubMembershipPageModule),
  },
  {
    path: 'player-edit-club-membership',
    loadChildren: () =>
      import(
        './pages/player-club-membership/player-edit-club-membership/player-edit-club-membership.module'
      ).then((m) => m.PlayerEditClubMembershipPageModule),
  },
  {
    path: 'player-list-club-membership',
    loadChildren: () =>
      import(
        './pages/player-club-membership/player-list-club-membership/player-list-club-membership.module'
      ).then((m) => m.PlayerListClubMembershipPageModule),
  },
  {
    path: 'player-pay-club-membership',
    loadChildren: () =>
      import(
        './pages/player-club-membership/player-pay-club-membership/player-pay-club-membership.module'
      ).then((m) => m.PlayerPayClubMembershipPageModule),
  },
  {
    path: 'player-statement-details',
    loadChildren: () =>
      import(
        './pages/modal-screens/player-statement-details/player-statement-details.module'
      ).then((m) => m.PlayerStatementDetailsPageModule),
  },
  // {
  //   path: 'initiate-payment',
  //   loadChildren: () => import('./pages/modal-screens/initiate-payment/initiate-payment.module').then(m => m.InitiatePaymentPageModule)
  // },
  {
    path: 'competition-list',
    loadChildren: () =>
      import(
        './pages/competition/competition-list/competition-list.module'
      ).then((m) => m.CompetitionListPageModule),
  },
  {
    path: 'competition-details',
    loadChildren: () =>
      import(
        './pages/competition/competition-details/competition-details.module'
      ).then((m) => m.CompetitionDetailsPageModule),
  },
  {
    path: 'booking-caddies-Buggies-details',
    loadChildren: () =>
      import(
        './pages/booking/booking-details/booking-caddies-Buggies-details/booking-caddies-Buggies-details.module'
      ).then((m) => m.BookingcaddiesBuggiesDetailsPageModule),
  },
  {
    path: 'additional-items',
    loadChildren: () =>
      import(
        './pages/booking/booking-details/additional-items/additional-items.module'
      ).then((m) => m.AdditionalItemsPageModule),
  },
  {
    path: 'booking-payment',
    loadChildren: () =>
      import(
        './pages/booking/booking-details/booking-payment/booking-payment.module'
      ).then((m) => m.BookingPaymentPageModule),
  },
  {
    path: 'add-player',
    loadChildren: () =>
      import(
        './pages/booking/booking-details/add-player/add-player.module'
      ).then((m) => m.AddPlayerPageModule),
  },
  {
    path: 'save-group',
    loadChildren: () =>
      import(
        './pages/booking/booking-details/save-group/save-group.module'
      ).then((m) => m.SaveGroupPageModule),
  },
  {
    path: 'payment-selection',
    loadChildren: () =>
      import(
        './pages/booking/booking-details/payment-selection/payment-selection.module'
      ).then((m) => m.PaymentSelectionPageModule),
  },
  {
    path: 'payment-history-refund',
    loadChildren: () =>
      import(
        './pages/booking/booking-details/payment-history-refund/payment-history-refund.module'
      ).then((m) => m.PaymentHistoryRefundPageModule),
  },
  {
    path: 'news-list',
    loadChildren: () =>
      import('./pages/news/news-list/news-list.module').then(
        (m) => m.NewsListModule
      ),
  },
  {
    path: 'promo-ads-list',
    loadChildren: () =>
      import('./pages/promo-ads/promo-ads-list/promo-ads-list.module').then(
        (m) => m.PromoAdsListModule
      ),
  },
  {
    path: 'player-facility-type-list',
    loadChildren: () =>
      import(
        './pages/booking/player-facility-type-list/player-facility-type-list.module'
      ).then((m) => m.PlayerFacilityTypeListPageModule),
  },
  {
    path: 'facility-details',
    loadChildren: () =>
      import('./pages/booking/facility-details/facility-details.module').then(
        (m) => m.FacilityDetailsPageModule
      ),
  },
  {
    path: 'facility-availablity',
    loadChildren: () => import('./pages/booking/facility-availablity/facility-availablity.module').then( m => m.FacilityAvailablityPageModule)
  },
  {
    path: 'facility-booking-details',
    loadChildren: () => import('./pages/booking/facility-booking-details/facility-booking-details.module').then( m => m.FacilityBookingDetailsPageModule)
  },
  {
    path: 'facility-payment-selection',
    loadChildren: () => import('./pages/booking/facility-payment-selection/facility-payment-selection.module').then( m => m.FacilityPaymentSelectionPageModule)
  },
  {
    path: 'organizer-list',
    loadChildren: () =>
      import('./pages/normalgame/organizer-list/organizer-list.module').then(
        (m) => m.OrganizerListPageModule
      ),
  },
  {
    path: 'competition-payment-selection',
    loadChildren: () =>
      import('./pages/competition/competition-payment-selection/competition-payment-selection.module').then(
        (m) => m.CompetitionPaymentSelectionPageModule
      ),
  },
  {
    path: 'find-tee-times',
    loadChildren: () =>
    import('./pages/booking/booking-home/search-tee-time/search-tee-time.module').then(
        (m) => m.SearchTeeTimeComponentModule
      ),
  },


];
@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      preloadingStrategy: PreloadAllModules,
      onSameUrlNavigation: 'reload',
      initialNavigation: 'enabledBlocking',
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
